export default __webpack_public_path__ + "static/team-member_m-67f2f04c1e60d3b89daa067170ec96d4.jpg";